import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Tile} from "../../Tile";

import {interval, Subscription} from "rxjs";
import {DigitaloutdetailsComponent} from "../digitaloutdetails/digitaloutdetails.component";
import {DigitalOutDescription, DOutDescription} from "../digitalOutDescription";
import {DigitalOutStatus, DOState} from "../digitalOutStatus";
import {DigitaloutDescriptionDataservice} from "../digitalout-description-dataservice";
import {DigitaloutStatusDataservice} from "../digitalout-status-dataservice";
import {environment} from "../../../environments/environment";


@Component({
  selector: 'app-digtaloutlist',
  templateUrl: './digitaloutlist.component.html',
  styleUrls: ['./digitaloutlist.component.css']
})
export class DigitaloutlistComponent implements OnInit, OnDestroy {
  tiles: Tile[] = [
    {text: 'Tile 1', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double purple'},
    {text: 'Tile 2', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double red'},
    {text: 'Tile 3', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double skyblue'},
    {text: 'Tile 4', cols: 1, rows: 8 ,color: 'lightblue', border: '3px double yellow'},
  ];

  @Input()
  public dOutDescription: DigitalOutDescription | undefined;
  public dOutStatus: DigitalOutStatus | undefined;
  private updateSubscription: Subscription | undefined;
  public errorMessage: string = "";
  public componentList = Array<DigitaloutdetailsComponent>();
  public loaderStatus: number = 0;

  constructor(private digitaloutDescriptionDataservice: DigitaloutDescriptionDataservice,
              private digitaloutStatusDataservice: DigitaloutStatusDataservice           )  {
  }

  InitLayout(): void {
    this.digitaloutDescriptionDataservice.GetData().subscribe({
      next: dOutDescription => {
        console.log('DO Layout update');
        this.dOutDescription = dOutDescription;
        this.componentList.forEach((detail => {
          detail.UpdateLayoutData(this.GetDescription(detail.refNumber));
        }))
      },
      error: err => { this.errorMessage = err ;
      console.log("DO Layout Error:", err);
      }
    });
  }

  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;
    this.digitaloutStatusDataservice.GetData().subscribe(
      {
        next: dOutStatus => {
          this.loaderStatus = 1;
          this.dOutStatus = dOutStatus;
          for(let detail of this.componentList)  {
            detail.UpdateDoState(this.GetStatus(detail.refNumber));
          }
          this.ReSubscribe();
        }, error: err => { this.errorMessage = err;
        }
      });
  }


  ngOnInit(): void {
    this.InitLayout();
    this.UpdateData();
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }


  Add(digitaloutDetail: DigitaloutdetailsComponent): void
  {
    this.componentList.push(digitaloutDetail);
  }

  GetDescription(refNumber: number): DOutDescription {
    if( ( this.dOutDescription) && (this.dOutDescription.DO[refNumber]))
      return this.dOutDescription.DO[refNumber];
    return new DOutDescription();
  }

  GetStatus(refNumber: number): DOState {
    if( ( this.dOutStatus) && (this.dOutStatus.DO[refNumber]))
      return this.dOutStatus.DO[refNumber];
    return new DOState();
  }


}
